import React from 'react';
import Footer from '../components/Footer';
import Navbar from '../components/Navbar';

const About = () => {
	return (
		<div>
			<Navbar />
			<p>About Page</p>
			<Footer />
		</div>
	);
};

export default About;
